import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { acceptPaymentResponsibility } from './actions';
import { useDispatch } from 'react-redux';
import { UIProperty } from '@api/v1';

export const AcceptingPaymentResponsibilityDialog = ({
	open,
	property,
	closeAcceptingDialog
}: {
	open: boolean;
	property: UIProperty | null;
	closeAcceptingDialog: () => void;
}) => {
	const dispatch = useDispatch();
	const isPaid = () => property?.paymentResponsibility?.casaviCostTakeoverApprovedAt !== null;
	return (
		<Dialog open={open}>
			<DialogTitle>
				<Trans
					i18nKey="properties:accepting_payment_responsibility_dialog_header"
					values={{ propertyName: property ? property.name : '' }}
				/>
			</DialogTitle>
			<DialogContent>
				{isPaid() ? (
					<Trans i18nKey="properties:accepting_payment_responsibility_dialog_content_paid" />
				) : (
					<Trans i18nKey="properties:accepting_payment_responsibility_dialog_content_unpaid" />
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => closeAcceptingDialog()}>
					<Trans i18nKey="general:cta_cancel" />
				</Button>
				<Button
					color="primary"
					disabled={property?.id === null}
					onClick={() => {
						if (property?.id !== null) {
							dispatch(acceptPaymentResponsibility(String(property.id)));
							closeAcceptingDialog();
						}
					}}
				>
					{property?.paymentResponsibility?.casaviCostTakeoverApprovedAt ? (
						<Trans i18nKey="properties:accepting_payment_responsibility_button_paid" />
					) : (
						<Trans i18nKey="properties:accepting_payment_responsibility_button_unpaid" />
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
